import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebaseConfig';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import GeneralNavbar from './GeneralNavbar';
import './DownloadProductExcel.css';
import './GeneralNavbar.css';

const DownloadProductExcel = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedName, setSelectedName] = useState('');
  const [selectedStockFilter, setSelectedStockFilter] = useState('');
  const [categories, setCategories] = useState([]);
  const [names, setNames] = useState([]);
  const [isLoading, setIsLoading] = useState(false);


  const handleBack = () => {
    window.history.back();
  };

  useEffect(() => {
    const fetchProducts = async () => {
      const snapshot = await getDocs(collection(db, 'products'));
      const productList = [];

      snapshot.forEach(doc => {
        const data = doc.data();
        productList.push({
        docId: doc.id,
        name: data.name || '',
        description: data.description || '',
        category: data.category || '',
        price: Number(data.price) || 0,
        stock: Number(data.stock) || 0,
        discount: data.discount || 0,
        discountInPesos: data.discountInPesos || 0,
        enabled: data.enabled ? 'Sí' : 'No',
        id: data.id || 0,
        image: data.image || ''
      });

      });

      setProducts(productList);
      setFilteredProducts(productList);

      const uniqueCategories = [...new Set(productList.map(p => p.category).filter(Boolean))];
      const uniqueNames = [...new Set(productList.map(p => p.name).filter(Boolean))];

      setCategories(uniqueCategories);
      setNames(uniqueNames);
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    let result = products;

    if (selectedCategory) {
      result = result.filter(p => p.category === selectedCategory);
    }
    if (selectedName) {
      result = result.filter(p => p.name === selectedName);
    }
    if (selectedStockFilter) {
      if (selectedStockFilter === 'sinStock') {
        result = result.filter(p => p.stock === 0);
      } else if (selectedStockFilter === 'pocoStock') {
        result = result.filter(p => p.stock > 0 && p.stock < 10);
      } else if (selectedStockFilter === 'stockSuficiente') {
        result = result.filter(p => p.stock >= 10);
      }
    }

    setFilteredProducts(result);
  }, [selectedCategory, selectedName, selectedStockFilter, products]);

  const handleDownload = () => {
     setIsLoading(true); // ⏳ Mostrar pantalla de carga
    try {
      const worksheet = XLSX.utils.json_to_sheet(filteredProducts);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Productos');

      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      const dataBlob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      saveAs(dataBlob, 'productos-filtrados.xlsx');
      console.log('✅ Excel generado correctamente');
    } catch (error) {
      console.error('❌ Error al generar Excel:', error);
    } finally {
    setTimeout(() => setIsLoading(false), 2000); // dar tiempo para que se descargue
  }
  };

  return (
    <>
      <GeneralNavbar title="Exportar Productos" onBackClick={handleBack} />

      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <p className="loading-message">Generando Excel, por favor espera...</p>
        </div>
      )}

      <div className="download-excel-container">
        <div className="filters">
          <label>
            Categoría:
            <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)}>
              <option value=''>Todas</option>
              {categories.map((cat, index) => (
                <option key={index} value={cat}>{cat}</option>
              ))}
            </select>
          </label>

          <label>
            Marca (nombre):
            <select value={selectedName} onChange={e => setSelectedName(e.target.value)}>
              <option value=''>Todas</option>
              {names.map((name, index) => (
                <option key={index} value={name}>{name}</option>
              ))}
            </select>
          </label>

          <label>
            Stock:
            <select value={selectedStockFilter} onChange={e => setSelectedStockFilter(e.target.value)}>
              <option value=''>Todos</option>
              <option value='sinStock'>Sin stock</option>
              <option value='pocoStock'>Poco stock (&lt;10)</option>
              <option value='stockSuficiente'>Stock suficiente (10+)</option>
            </select>
          </label>
        </div>

        <button className="download-button" onClick={handleDownload}>
          Descargar Productos en Excel
        </button>
      </div>
    </>
  );
};

export default DownloadProductExcel;

